var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { getDefaultHomePath } from "./routes";
export var ProtectedRoute = function (_a) {
    var allowedRoles = _a.allowedRoles, children = _a.children;
    var location = useLocation();
    var _b = useAuth(), initialized = _b.initialized, isAuthenticated = _b.isAuthenticated, isLoadingAuth = _b.isLoadingAuth, profileError = _b.profileError, role = _b.role;
    if (!initialized || isLoadingAuth) {
        return (_jsx(Box, __assign({ sx: {
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                minHeight: "40vh",
            } }, { children: _jsxs(Stack, __assign({ alignItems: "center", maxWidth: 460, spacing: 2.5 }, { children: [_jsx(CircularProgress, {}), _jsx(Typography, __assign({ variant: "h6" }, { children: "Carregando seu perfil de acesso..." })), _jsx(Typography, __assign({ align: "center", color: "text.secondary" }, { children: "O ParticiPE esta validando o token do Smartpass e as permissoes locais antes de liberar a tela solicitada." }))] })) })));
    }
    if (!isAuthenticated || !role || !allowedRoles.includes(role)) {
        return (_jsx(Navigate, { replace: true, state: {
                deniedPath: location.pathname,
                reason: profileError ? "profile-error" : "forbidden",
            }, to: getDefaultHomePath(role) }));
    }
    if (profileError) {
        return (_jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(Alert, __assign({ severity: "warning" }, { children: profileError })), children] })));
    }
    return _jsx(_Fragment, { children: children });
};
